import { IStyle } from '@fluentui/react/lib/Styling';
import { RibbonTableStylesGalleryButtonProps } from '@1js/acui-ribbon-like';
import { AppFullGallerySection } from '@1js/acui-gallery';
import { TableColors } from './tablesEnum/tableColors';
import { PredefinedTableStyles } from './tablesEnum/predefinedTableStylesEnum';

const DefaultTable = (borderColor: string, color?: string): IStyle[] => {
    return Array(9).fill({
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    });
};

const PlainListTable = (borderColor: string, color?: string): IStyle[] => {
    return Array(9).fill({
        borderTop: `0.1px solid ${borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    });
};

const PlainTable = (borderColor: string, color?: string): IStyle[] => [
    {
        color: `${color || borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
    },
    {
        color: `${color || borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
    },
    {
        color: `${color || borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
    },
    {
        color: `${color || borderColor}`,
        backgroundColor: `${color}20`,
        borderRight: `0.1px solid ${borderColor}`,
    },
    {
        color: `${color || borderColor}`,
        backgroundColor: `${color}20`,
    },
    {
        color: `${color || borderColor}`,
        backgroundColor: `${color}20`,
    },
    {
        color: `${color || borderColor}`,
        borderRight: `0.1px solid ${borderColor}`,
    },
    {
        color: `${color || borderColor}`,
    },
    {
        color: `${color || borderColor}`,
    },
];

const PlainWithoutBorders = (color: string): IStyle[] => [
    {
        color: `${color}`,
    },
    {
        color: `${color}`,
    },
    {
        color: `${color}`,
    },
    {
        color: `${color}`,
        backgroundColor: `${color}20`,
    },
    {
        color: `${color}`,
        backgroundColor: `${color}20`,
    },
    {
        color: `${color}`,
        backgroundColor: `${color}20`,
    },
    {
        color: `${color}`,
    },
    {
        color: `${color}`,
    },
    {
        color: `${color}`,
    },
];

const PlainWithFirstColumn = (borderColor: string, color?: string): IStyle[] => [
    {
        color: `${color || borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
    },
    {
        color: `${color || borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
    },
    {
        color: `${color || borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
    },
    {
        color: `${color || borderColor}`,
        borderRight: `0.1px solid ${borderColor}`,
    },
    {
        color: `${color || borderColor}`,
        backgroundColor: `${color}20`,
    },
    {
        color: `${color || borderColor}`,
        backgroundColor: `${color}20`,
    },
    {
        color: `${color || borderColor}`,
        borderRight: `0.1px solid ${borderColor}`,
    },
    {
        color: `${color || borderColor}`,
    },
    {
        color: `${color || borderColor}`,
    },
];

const GridTable = (borderColor: string, color?: string): IStyle[] => [
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        backgroundColor: `${borderColor}20`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        backgroundColor: `${borderColor}20`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        backgroundColor: `${borderColor}20`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
];

const EspecialGrid = (borderColor: string, color?: string): IStyle[] => [
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        borderRightColor: TableColors.transparent,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        borderRightColor: TableColors.transparent,
        borderLeftColor: TableColors.transparent,
    },
    {
        border: `0.1px solid ${borderColor}`,
        borderRightColor: TableColors.transparent,
        color: `${color || borderColor}`,
        borderLeftColor: TableColors.transparent,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        borderBottomColor: TableColors.transparent,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        backgroundColor: `${borderColor}20`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        backgroundColor: `${borderColor}20`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        borderBottomColor: TableColors.transparent,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
];

const GridWitHeader = (borderColor: string, color?: string): IStyle[] => [
    {
        border: `0.1px solid ${borderColor}`,
        color: TableColors.white,
        backgroundColor: `${borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: TableColors.white,
        backgroundColor: `${borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: TableColors.white,
        backgroundColor: `${borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        backgroundColor: `${borderColor}20`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        backgroundColor: `${borderColor}20`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        backgroundColor: `${borderColor}20`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
];

const ListTable = (borderColor: string, color?: string): IStyle[] => [
    {
        borderTop: `0.1px solid ${borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
    {
        borderTop: `0.1px solid ${borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
    {
        borderTop: `0.1px solid ${borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
    {
        borderTop: `0.1px solid ${borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        backgroundColor: `${borderColor}20`,
    },
    {
        borderTop: `0.1px solid ${borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        backgroundColor: `${borderColor}20`,
    },
    {
        borderTop: `0.1px solid ${borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        backgroundColor: `${borderColor}20`,
    },
    {
        borderTop: `0.1px solid ${borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
    {
        borderTop: `0.1px solid ${borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
    {
        borderTop: `0.1px solid ${borderColor}`,
        borderBottom: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
    },
];

const ListWithHeader = (borderColor: string, color?: string): IStyle[] => [
    {
        border: `0.1px solid ${borderColor}`,
        color: TableColors.white,
        backgroundColor: `${borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: TableColors.white,
        backgroundColor: `${borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: TableColors.white,
        backgroundColor: `${borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        borderRightColor: TableColors.transparent,
        color: `${color || borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        borderRightColor: TableColors.transparent,
        borderLeftColor: TableColors.transparent,
        color: `${color || borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        borderLeftColor: TableColors.transparent,
        color: `${color || borderColor}`,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        borderRightColor: TableColors.transparent,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        borderRightColor: TableColors.transparent,
        borderLeftColor: TableColors.transparent,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        borderLeftColor: TableColors.transparent,
    },
];

const ListEspecial = (borderColor: string, color?: string): IStyle[] => [
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        borderRightColor: TableColors.transparent,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        borderRightColor: TableColors.transparent,
        borderLeftColor: TableColors.transparent,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        borderRightColor: TableColors.transparent,
        borderLeftColor: TableColors.transparent,
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        borderBottom: 'none',
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        backgroundColor: `${borderColor}20`,
        borderRight: 'none',
        borderBottom: 'none',
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        backgroundColor: `${borderColor}20`,
        borderRight: 'none',
        borderLeft: 'none',
        borderBottom: 'none',
    },
    {
        border: `0.1px solid ${borderColor}`,
        color: `${color || borderColor}`,
        borderTopColor: TableColors.transparent,
        borderBottomColor: TableColors.transparent,
    },
    {
        border: `0.1px solid ${color}`,
        color: `${color || borderColor}`,
        borderBottom: 'none',
        borderRight: 'none',
        borderTop: 'none',
    },
    {
        border: 'none',
        color: `${color || borderColor}`,
    },
];

const plainTables = (
    isDarkMode: boolean
): AppFullGallerySection<RibbonTableStylesGalleryButtonProps> => {
    return {
        title: 'Plain tables',
        galleryButtons: [
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.defaultBlack,
                columns: 3,
                tableCellStyles: DefaultTable(
                    TableColors.black,
                    isDarkMode ? TableColors.white : undefined
                ),
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.defaultGray,
                tableCellStyles: DefaultTable(
                    TableColors.gray,
                    isDarkMode ? TableColors.white : TableColors.black
                ),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.gridBlack,
                tableCellStyles: GridTable(
                    TableColors.black,
                    isDarkMode ? TableColors.white : undefined
                ),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.plainListBlack,
                tableCellStyles: PlainListTable(
                    TableColors.black,
                    isDarkMode ? TableColors.white : undefined
                ),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.plainBlack,
                tableCellStyles: PlainTable(
                    TableColors.black,
                    isDarkMode ? TableColors.white : undefined
                ),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.plainWithoutBordersBlack,
                tableCellStyles: PlainWithoutBorders(TableColors.black),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.plainWithFirstColumnBlack,
                tableCellStyles: PlainWithFirstColumn(
                    TableColors.black,
                    isDarkMode ? TableColors.white : undefined
                ),
                columns: 3,
            },
        ],
    };
};

export const firstLineOfGridTables = (
    isDarkMode: boolean,
    isInPreview: boolean
): RibbonTableStylesGalleryButtonProps[] => [
    {
        type: 'AppGalleryButtonProps',
        id: PredefinedTableStyles.gridBlack,
        tableCellStyles: GridTable(TableColors.black, isDarkMode ? TableColors.white : undefined),
        columns: 3,
        style: {
            root: {
                paddingLeft: isInPreview ? '6px' : '4px',
            },
        },
    },
    {
        type: 'AppGalleryButtonProps',
        id: PredefinedTableStyles.gridBlue,
        tableCellStyles: GridTable(TableColors.blue),
        columns: 3,
    },
    {
        type: 'AppGalleryButtonProps',
        id: PredefinedTableStyles.gridOrange,
        tableCellStyles: GridTable(TableColors.orange),
        columns: 3,
    },
    {
        type: 'AppGalleryButtonProps',
        id: PredefinedTableStyles.gridYellow,
        tableCellStyles: GridTable(TableColors.yellow),
        columns: 3,
    },
    {
        type: 'AppGalleryButtonProps',
        id: PredefinedTableStyles.gridRed,
        tableCellStyles: GridTable(TableColors.red),
        columns: 3,
    },
    {
        type: 'AppGalleryButtonProps',
        id: PredefinedTableStyles.gridPurple,
        tableCellStyles: GridTable(TableColors.purple),
        columns: 3,
    },
    {
        type: 'AppGalleryButtonProps',
        id: PredefinedTableStyles.gridGreen,
        tableCellStyles: GridTable(TableColors.green),
        columns: 3,
        style: {
            root: {
                paddingRight: isInPreview ? '6px' : '4px',
            },
        },
    },
];

const gridTables = (
    isDarkMode: boolean
): AppFullGallerySection<RibbonTableStylesGalleryButtonProps> => {
    return {
        title: 'Grid tables',
        galleryButtons: [
            ...firstLineOfGridTables(isDarkMode, false /** isInPreview */),
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.especialGridBlack,
                tableCellStyles: EspecialGrid(
                    TableColors.black,
                    isDarkMode ? TableColors.white : ''
                ),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.especialGridBlue,
                tableCellStyles: EspecialGrid(TableColors.blue),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.especialGridOrange,
                tableCellStyles: EspecialGrid(TableColors.orange),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.especialGridYellow,
                tableCellStyles: EspecialGrid(TableColors.yellow),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.especialGridRed,
                tableCellStyles: EspecialGrid(TableColors.red),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.especialGridPurple,
                tableCellStyles: EspecialGrid(TableColors.purple),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.especialGridGreen,
                tableCellStyles: EspecialGrid(TableColors.green),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.gridWithHeaderBlack,
                tableCellStyles: GridWitHeader(
                    TableColors.black,
                    isDarkMode ? TableColors.white : undefined
                ),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.gridWithHeaderBlue,
                tableCellStyles: GridWitHeader(TableColors.blue),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.gridWithHeaderOrange,
                tableCellStyles: GridWitHeader(TableColors.orange),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.gridWithHeaderYellow,
                tableCellStyles: GridWitHeader(TableColors.yellow),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.gridWithHeaderRed,
                tableCellStyles: GridWitHeader(TableColors.red),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.gridWithHeaderPurple,
                tableCellStyles: GridWitHeader(TableColors.purple),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.gridWithHeaderGreen,
                tableCellStyles: GridWitHeader(TableColors.green),
                columns: 3,
            },
        ],
    };
};

const listTable = (
    isDarkMode: boolean
): AppFullGallerySection<RibbonTableStylesGalleryButtonProps> => {
    return {
        title: 'List tables',
        galleryButtons: [
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listBlack,
                tableCellStyles: ListTable(
                    TableColors.black,
                    isDarkMode ? TableColors.white : undefined
                ),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listBlue,
                tableCellStyles: ListTable(TableColors.blue),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listOrange,
                tableCellStyles: ListTable(TableColors.orange),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listYellow,
                tableCellStyles: ListTable(TableColors.yellow),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listRed,
                tableCellStyles: ListTable(TableColors.red),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listPurple,
                tableCellStyles: ListTable(TableColors.purple),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listGreen,
                tableCellStyles: ListTable(TableColors.green),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listWithHeaderBlack,
                tableCellStyles: ListWithHeader(
                    TableColors.black,
                    isDarkMode ? TableColors.white : undefined
                ),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listWithHeaderBlue,
                tableCellStyles: ListWithHeader(TableColors.blue),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listWithHeaderOrange,
                tableCellStyles: ListWithHeader(TableColors.orange),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listWithHeaderYellow,
                tableCellStyles: ListWithHeader(TableColors.yellow),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listWithHeaderRed,
                tableCellStyles: ListWithHeader(TableColors.red),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listWithHeaderPurple,
                tableCellStyles: ListWithHeader(TableColors.purple),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listWithHeaderGreen,
                tableCellStyles: ListWithHeader(TableColors.green),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listEspecialBlack,
                tableCellStyles: ListEspecial(
                    TableColors.black,
                    isDarkMode ? TableColors.white : undefined
                ),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listEspecialBlue,
                tableCellStyles: ListEspecial(TableColors.blue),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listEspecialOrange,
                tableCellStyles: ListEspecial(TableColors.orange),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listEspecialYellow,
                tableCellStyles: ListEspecial(TableColors.yellow),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listEspecialRed,
                tableCellStyles: ListEspecial(TableColors.red),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listEspecialPurple,
                tableCellStyles: ListEspecial(TableColors.purple),
                columns: 3,
            },
            {
                type: 'AppGalleryButtonProps',
                id: PredefinedTableStyles.listEspecialGreen,
                tableCellStyles: ListEspecial(TableColors.green),
                columns: 3,
            },
        ],
    };
};

export const multiSectionFullGallerySections = (
    isDarkMode: boolean
): AppFullGallerySection<RibbonTableStylesGalleryButtonProps>[] => [
    plainTables(isDarkMode),
    gridTables(isDarkMode),
    listTable(isDarkMode),
];
